<img [src]="config.getAssetUrl('images/404.png')">
<h1 trans>Opps! We can't find the page you're looking for.</h1>
<a routerLink="/" mat-raised-button color="primary" trans>Home</a>